import { useQuery } from "@tanstack/react-query";
import type { StoreSubscriptionStatusView } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import {
  ApiJsonClientError,
  apiJsonClient,
} from "@/lib/query/core/api-json-client";
import { queryKeys } from "@/lib/query/core/query-keys";

type UseStoreSubscriptionQueryParams = {
  storeSlug: string;
};

export function useStoreSubscriptionQuery({
  storeSlug,
}: UseStoreSubscriptionQueryParams) {
  const query = useQuery({
    queryKey: queryKeys.seller.storeSubscription(storeSlug),
    queryFn: async (): Promise<StoreSubscriptionStatusView | null> => {
      try {
        return await apiJsonClient<StoreSubscriptionStatusView>(
          endpoints.seller.storeSubscription,
          { cache: "no-store" },
        );
      } catch (error) {
        // A seller without an active subscription is a normal state, not an
        // error worth breaking the dashboard over.
        if (error instanceof ApiJsonClientError && error.status === 404) {
          return null;
        }
        throw error;
      }
    },
    enabled: storeSlug.length > 0,
  });

  return {
    data: query.data ?? null,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
